import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

const StyledDynamicSchemaDashboard = styled.div`
  width: 100%;
  height: calc(100%-80px);
  padding: 40px;
`;

const DynamicSchemaDashboard: React.FunctionComponent<Object> = () => {
  return (
    <StyledDynamicSchemaDashboard data-testid="dynamic-schema-dashboard-view">
      <Outlet />
    </StyledDynamicSchemaDashboard>
  );
};

export default DynamicSchemaDashboard;
